<script setup lang="ts">
import { useSubjectsStore } from '@/stores/subjects'
import type { Subject } from '@/types'
import FosButton from '@/components/ui/FosButton.vue'

defineProps<{
  subjects: Subject[]
  activeSubjectId: string | null
}>()

const emit = defineEmits<{
  select: [subjectId: string]
  add: []
}>()

const subjectsStore = useSubjectsStore()

function select(id: string) {
  subjectsStore.setActiveSubject(id)
  emit('select', id)
}
</script>

<template>
  <div class="flex items-center gap-1">
    <button
      v-for="subject in subjects"
      :key="subject.subject_id"
      type="button"
      class="px-4 py-2.5 text-xs font-mono uppercase tracking-widest border-b-2 -mb-px transition-colors"
      :class="
        subject.subject_id === (activeSubjectId ?? subjects[0]?.subject_id)
          ? 'border-primary text-primary'
          : 'border-transparent text-outline hover:text-on-surface'
      "
      @click="select(subject.subject_id)"
    >
      {{ subject.first_name }} {{ subject.last_name }}
    </button>

    <FosButton variant="tertiary" size="sm" class="ml-2" @click="emit('add')">+ Add Subject</FosButton>
  </div>
</template>
